<template>
  <v-col>
    <v-row justify="center">
      <v-row class="ma-2">
        <v-col cols="12" md="6">
          <v-row class="mb-2">
            <v-icon class="black-color" @click="$emit('close')">
              mdi-arrow-left
            </v-icon>
            <h4 class="grey-color mx-4" style="font-weight: 500">
              Create Notification
            </h4>
          </v-row>
        </v-col>
        <v-col cols="12" md="6" class="pa-0">
          <v-row justify="center" justify-md="end">
            <v-btn @click="sendNotification()" color="#e022d1" dark rounded width="240px" class="mb-8">
              Send Notification
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-row>
    <v-row justify="center">
      <div class="white-card">
        <v-col class="pa-8">
          <v-form ref="form">
            <v-row justify-md="start" justify="center" class="ma-0">
              <h2 class="fs400 mt-10 mb-2">Create Notification</h2>
            </v-row>
            <v-row justify-md="start" justify="center" class="ma-0">
              <v-col cols="12" md="3">
                <v-row justify="center" justify-md="start" class="ma-0">
                  <v-select required :rules="nullRules" style="max-width: 240px" class="input" label="User Type" rounded
                    v-model="userType" :items="userTypes"></v-select>
                </v-row>
              </v-col>
              <v-col cols="12" md="3">
                <v-row justify="center" justify-md="start" class="ma-0">
                  <v-select required :rules="nullRules" style="max-width: 240px" class="input" label="Type" rounded
                    v-model="type" :items="types"></v-select>
                </v-row>
              </v-col>
            </v-row>
            <v-row justify-md="start" justify="center" class="ma-0">
              <p style="color: grey">Message Description</p>
            </v-row>
            <v-row justify-md="start" justify="center" class="ma-0">
              <v-textarea v-model="message" required :rules="nullRules" style="max-width: 500px" outlined></v-textarea>
            </v-row>
          </v-form>
        </v-col>
      </div>
    </v-row>
    <v-dialog v-model="promptDialog" max-width="480">
      <v-card class="pa-8" elevation="4" shaped style="border-radius: 24px">
        <v-card-text class="text-center">
          <v-icon size="96" color="red" v-if="promptType == 'error'">
            mdi-alert-circle
          </v-icon>
          <v-icon size="96" color="green" v-if="promptType == 'success'">
            mdi-check-circle
          </v-icon>
          <div class="text-h5 my-6" v-if="promptType == 'error'">Error</div>
          <div class="text-h5 my-6" v-if="promptType == 'success'">Success</div>
          <div class="body-1 text-h6">{{ promptMessage }}</div>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn color="black" dark depressed large style="border-radius: 24px" @click="promptDialog = false">
            CLOSE
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row justify="center">
      <v-overlay :value="loading">
        <v-progress-circular :size="100" color="#4390c0" indeterminate></v-progress-circular>
      </v-overlay>
    </v-row>
  </v-col>
</template>

<script>
import {
  collection,
  getDocs,
  where,
  getFirestore,
  setDoc,
  query,
  getDoc,
  doc,
  addDoc,
} from "firebase/firestore";
import { firebaseApp } from "../../firebaseConfig";
const db = getFirestore(firebaseApp);

import { logAction } from "@/utils/firestoreUtil";

export default {
  data() {
    return {
      idNumberRules: [
        (v) => !!v || "ID number is required",
        (v) => /^\d{13}$/.test(v) || "ID number must be exactly 13 digits",
      ],
      emailRules: [
        (v) => !!v || "Email is required",
        (v) => /.+@.+\..+/.test(v) || "Email must be valid",
      ],
      passwordRules: [
        (v) => !!v || "Password is required",
        (v) => (v && v.length >= 6) || "Password must be at least 6 characters",
        (v) =>
          /(?=.*[A-Z])/.test(v) ||
          "Password must contain at least one uppercase letter",
        (v) =>
          /(?=.*[a-z])/.test(v) ||
          "Password must contain at least one lowercase letter",
        (v) =>
          /(?=.*[0-9])/.test(v) || "Password must contain at least one number",
        (v) =>
          /(?=.*[!@#+*\$%\^&])/.test(v) ||
          "Password must contain at least one special character",
      ],
      nullRules: [(v) => !!v || "Field is required"],
      contactRules: [
        (v) => !!v || "Contact is required",
        (v) =>
          /^\d{10}$/.test(v) || "Contact must be valid number with 10 digits",
      ],
      numberRules: [
        (v) => !!v || "Field is required",
        (v) => /^\d+$/.test(v) || "Field must be numbers only",
      ],
      letterRules: [
        (v) => !!v || "Field is required",
        (v) => /^[A-Za-z]+$/ || "Field must only contain letters",
      ],
      userType: null,
      user: null,
      type: null,
      message: null,
      userTypes: ["Doctors", "Users"],
      types: ["General", "Important"],
      promptDialog: false,
      promptMessage: "",
      promptType: "",
      doctors: [],
      loading: false,
    };
  },
  methods: {
    async sendNotification() {
      let valid = this.$refs.form.validate();

      if (!valid) {
        this.promptMessage =
          "Please ensure all fields are filled in and valid!";
        this.promptType = "error";
        this.promptDialog = true;
        return;
      }

      let newNotification = {
        type: this.type,
        userType: this.userType,
        message: this.message,
        date: new Date().toISOString().substring(0, 10),
        time: new Date().toTimeString().substring(0, 8),
      };

      try {
        this.loading = true;
        let docRef = await addDoc(
          collection(db, "notifications"),
          newNotification
        );
        this.loading = false;

        // this.promptMessage = "The notification has been successfully sent!";
        // this.promptType = "success";
        // this.promptDialog = true;

        // setTimeout(() => {
        //   this.promptDialog = false;
        //   this.$router.go();
        // }, 3000);
        this.sendPush();
      } catch (error) {
        this.loading = false;
        console.log(error);
        this.promptMessage =
          "An error occured while sending the notification, please try again!";
        this.promptType = "error";
        this.promptDialog = true;
      }
    },
    async sendPush() {
      try {
        this.loading = true;
        const response = await fetch(
          "https://sendpushnotification-4woel4f54a-uc.a.run.app",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              title: this.type + " Notification",
              body: this.message,
              userType: this.userType // or "Users"
            })
          }
        );
        this.loading = false;

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();

        let res = await logAction('Notifications', 'Notification Sent', this.loggedInUser.email, this.loggedInUser.email + ' has sent a push notification');

        this.promptMessage = "The notification has been successfully sent!";
        this.promptType = "success";
        this.promptDialog = true;
        console.log("Response from Cloud Function:", data);
      } catch (error) {
        this.loading = false;
        console.error("Error sending notification:", error.message);
        this.promptMessage = "Something went wrong with sending the notification!";
        this.promptType = "error";
        this.promptDialog = true;
      }
    }
  },
  created() {

  },
  computed: {
    loggedInUser() {
      return this.$store.state.user || {};
    },
  }
};
</script>

<style></style>